var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    viewBox: "0 0 25.567 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-776 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 12.749,
    height: 2.499,
    rx: 1.25,
    transform: "translate(776 462)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 25.567,
    height: 2.499,
    rx: 1.25,
    transform: "translate(776 469.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 17.972,
    height: 2.499,
    rx: 1.25,
    transform: "translate(776 477.501)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.6336f61d42aaf24298fd8ceca8a53e7d.svg";
export { ForwardRef as ReactComponent };